<script lang="ts">
  // Payment status of a time entry, built on Badge.
  //   <PaymentBadge status={e.payment_status} paid={e.amount_paid} />
  //   <PaymentBadge status={…} onclick={cycle} />   clickable: cycles the status
  import '../messages/ui';
  import Badge, { type BadgeTone } from './Badge.svelte';
  import { t } from '../i18n.svelte';
  import { formatMoney, normalizeStatus } from '../format';

  interface Props {
    status: string | null | undefined;
    paid?: number | null;
    onclick?: (event: MouseEvent) => void;
    disabled?: boolean;
    size?: 'xs' | 'sm' | 'md';
  }
  let { status, paid = null, onclick, disabled = false, size = 'md' }: Props = $props();

  const TONES: Record<ReturnType<typeof normalizeStatus>, BadgeTone> = { open: 'warning', partial: 'info', paid: 'success', non_billable: 'neutral' };
  const s = $derived(normalizeStatus(status));
</script>

{#snippet label()}
  {t(`payment.${s}`)}{#if s === 'partial' && paid}<span class="amt">· {formatMoney(paid)}</span>{/if}
{/snippet}

{#if onclick}
  <Badge
    tone={TONES[s]}
    {size}
    variant="plain"
    dot
    {disabled}
    tooltip={t('payment.cycle_hint')}
    onclick={(e) => {
      e.stopPropagation();
      onclick?.(e);
    }}
  >
    {@render label()}
  </Badge>
{:else}
  <Badge tone={TONES[s]} {size} variant="plain" dot>{@render label()}</Badge>
{/if}

<style>
  .amt { font-weight: var(--weight-medium); opacity: 0.85; }
</style>
